import { MenuItem, Select, SelectChangeEvent, Stack, SxProps, Theme } from "@mui/material"
import LanguageIcon from "@mui/icons-material/Language"
import { useTranslation } from "react-i18next"
import { SUPPORTED_LANGUAGES, SupportedLanguage, changeLanguageManually } from "../../core/i18n"

// Cada idioma aparece no próprio idioma, para quem não entende o atual achar o seu.
const LANGUAGE_LABELS: Record<SupportedLanguage, { short: string; name: string }> = {
  "pt-BR": { short: "PT", name: "Português" },
  en: { short: "EN", name: "English" },
  es: { short: "ES", name: "Español" },
}

interface LanguageSelectorProps {
  /** Cor do ícone e do texto (ex.: "white" sobre o cabeçalho verde do Layout 7). */
  color?: string
  sx?: SxProps<Theme>
}

/**
 * Troca o idioma do checkout na hora, sem recarregar nem perder o que já foi digitado.
 * A escolha fica salva e passa a valer sobre o idioma do navegador e o ?lang=.
 */
const LanguageSelector = ({ color = "#5D5E61", sx }: LanguageSelectorProps) => {
  const { t, i18n } = useTranslation()
  const current = (i18n.resolvedLanguage ?? "pt-BR") as SupportedLanguage

  const handleChange = (e: SelectChangeEvent<string>) => {
    void changeLanguageManually(e.target.value)
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={sx}>
      <LanguageIcon fontSize="small" sx={{ color }} />
      <Select
        variant="standard"
        disableUnderline
        value={current}
        onChange={handleChange}
        renderValue={(value) => LANGUAGE_LABELS[value as SupportedLanguage]?.short ?? value}
        inputProps={{ "aria-label": t("common.language"), "data-testid": "languageSelector" }}
        sx={{ color, fontSize: "14px", fontWeight: 600, "& .MuiSvgIcon-root": { color } }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem key={language} value={language}>
            {LANGUAGE_LABELS[language].name}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  )
}

export default LanguageSelector
